import { render, staticRenderFns } from "./ViewReceipt.vue?vue&type=template&id=2cc9d846&scoped=true&"
import script from "./ViewReceipt.vue?vue&type=script&lang=js&"
export * from "./ViewReceipt.vue?vue&type=script&lang=js&"
import style0 from "./ViewReceipt.vue?vue&type=style&index=0&id=2cc9d846&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc9d846",
  null
  
)

export default component.exports